import { Header } from "../../models/Header";
import {
  aVenir,
  dateDebut,
  dateEntree,
  dateFin,
  dateSortie,
  historique,
  indicateur,
  jrDemo,
  magasin,
  noSuccursale,
  p2,
  p2ParJour,
  planoPlateau,
  prendLaPlaceDe,
  qte,
  qteMinEntrepot,
  qteMinPlancher,
  remplacer,
  section,
  statut,
  surPlancher,
  ucc,
  ucc_indicateur,
  ventes,
  ventesParJour,
} from "./columns";

export const planoHeaders: Header[] = [
  indicateur,
  ucc_indicateur,
  noSuccursale,
  {
    ...magasin,
    field: "magasin.mag_nom_aff",
  },
  {
    ...section,
    field: "section.plans_nom",
  },
  statut,
  {
    ...ventes,
    field: "stats.planost_ventes"
  },
  {
    ...ventesParJour,
    field: "stats.ventes_jr"
  },
  {
    ...qte,
    field: "stats.planost_ventes_mcx"
  },
  {
    ...p2,
    field: "calcPlano.pcarre"
  },
  {
    ...p2ParJour,
    field: "stats.ventes_jr_p2"
  },
  dateDebut,
  dateFin,
  dateEntree,
  dateSortie,
  {
    ...jrDemo,
    field: "calcPlano.nbr_jr_demo"
  },
  {
    ...surPlancher,
    field: "calcPlano.sur_plancher"
  },
  prendLaPlaceDe,
  {
    ...historique,
    field: "calcPlano.histo"
  },
  {
    ...qteMinPlancher,
    field: "calcPlano.prodmin_qte_min"
  },
  {
    ...qteMinEntrepot,
    field: "calcPlano.prodmin_qte_bs"
  },
  aVenir,
  planoPlateau,
  remplacer,
  ucc,
];
